import React, { Component } from 'react';
import { translate } from "react-multi-lang";

let baseUrl = window.location.origin;
let hostname = window.location.hostname;

let websiteUrl, cmsUrl;

if (baseUrl == "http://localhost:3002" || hostname == "localhost") {
  websiteUrl = baseUrl;
  cmsUrl = "http://uatcms.pgrkam.com"
}
else if (hostname == "uatweb.pgrkam.com") {
  websiteUrl = baseUrl;
  cmsUrl = "https://uatcms.pgrkam.com"
}
else if (hostname == "pgrkam.com") {
  websiteUrl = baseUrl;
  cmsUrl = "https://cms.pgrkam.com"
}
else {
  websiteUrl = baseUrl;
  cmsUrl = "https://uatcms.pgrkam.com"
}


class WebPolicy extends Component {

  render() {
    return (
      <div className="tab-content" >
        <div id="home" className=" tab-pane active">
          <section className="login-form mt-0">
            <div className="container">
              <div className="row">
                <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow   mb-3 mt-3  ">
                  <div className="panel-heading">
                    <div className="mb-0">{this.props.t("secreenReder.punjab_rojgar", { param: "react" })}</div>
                  </div>
                  <div className="panel-body p-policy pt-0  p-3 ">
                    <p className="mt-3">
                      <strong>{this.props.t("secreenReder.punjab_rojgar", { param: "react" })}</strong>{this.props.t("webPolicy.policy1", { param: "react" })}
                    </p>

                    <p>
                      {this.props.t("webPolicy.policy2", { param: "react" })}
                    </p>

                    <p>
                      {this.props.t("webPolicy.policy3", { param: "react" })}
                    </p>

                    <strong className='pb-2 d-block pHeading pHeadingwes'>{this.props.t("webPolicy.heading1", { param: "react" })}</strong>
                    <div className="policypage ankera">
                      <a aria-label='Go to Copyright Policy page'
                        href={`${websiteUrl}/copyright-policy`} className="mb-2">✅ {this.props.t("webPolicy.heading2", { param: "react" })}</a>

                      <a aria-label='Go to CMAP policy page'
                        href={`${cmsUrl}/cmap-policy`} className="mb-2">✅ {this.props.t("webPolicy.heading3", { param: "react" })} </a>

                      <a aria-label='Go to Accessibility Statement page'
                        href={`${cmsUrl}/content-archival-(cap)-policy`} className="mb-2">✅ {this.props.t("webPolicy.heading4", { param: "react" })}</a>

                      <a aria-label='Go to Content Review Policy (CRP) page'
                        href={`${cmsUrl}/content-review-(crp)-policy`} className="mb-2">✅ {this.props.t("webPolicy.heading5", { param: "react" })}</a>

                      <a aria-label='Go to Hyperlinking Policy page'
                        href={`${cmsUrl}/hyperlinking-policy`} className="mb-2">✅ {this.props.t("webPolicy.heading6", { param: "react" })}</a>

                      <a aria-label='Go to Privacy Policy page'
                        href={`${websiteUrl}/privacy-policy`} className="mb-2">✅ {this.props.t("webPolicy.heading7", { param: "react" })}</a>

                      <a aria-label='Go to Terms & Conditions page'
                        href={`${cmsUrl}/terms-&-conditions`} className="mb-2">✅ {this.props.t("webPolicy.heading8", { param: "react" })}</a>

                      <a aria-label='Go to Website Monitoring Plan page'
                        href={`${cmsUrl}/website-monitoring-plan`} className="mb-2">✅ {this.props.t("webPolicy.heading9", { param: "react" })}</a>

                      <a aria-label='Go to Contingency Management Plan page'
                        href={`${cmsUrl}/contingency-management-plan`} className="mb-2">✅ {this.props.t("webPolicy.heading10", { param: "react" })}</a>

                      {/* <a href="" className="mb-2">✅ Content Contribution, Moderation, and Approval Policy (CMAP)</a> */}

                      <a aria-label='Go to Security Policy page'
                        href={`${cmsUrl}/security-policy`} className="mb-2">✅ {this.props.t("webPolicy.heading11", { param: "react" })}</a>

                      <a aria-label='Go to Web Information Manager (WIM) page'
                        href={`${cmsUrl}/web-information-manager-(wim)`} className="mb-2">✅ {this.props.t("webPolicy.heading12", { param: "react" })}</a>

                    </div>

                    <strong className='pb-2 d-block pHeading pHeadingwes'>{this.props.t("webPolicy.heading13", { param: "react" })}</strong>
                    <p>
                      {this.props.t("webPolicy.policy4", { param: "react" })}
                    </p>
                    <p>
                      {this.props.t("webPolicy.policy5", { param: "react" })}<a> {this.props.t("webPolicy.policy6", { param: "react" })}</a>  {this.props.t("webPolicy.policy7", { param: "react" })}.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div >
      </div >
    )
  }
}

export default translate(WebPolicy);